const getters = {
  language: (state) => state.app.language,
  token: (state) => state.user.token,
  name: (state) => state.user.name,
  avatar: (state) => state.user.avatar,
  roles: (state) => state.user.roles,
  isAdmin: (state) => state.user.isAdmin,
  permissions: (state) => state.user.permissions,
  userInfo: (state) => state.user.userInfo,
  sidebarRouters: (state) => state.permission.sidebarRouters,
  allRoutes: (state) => state.permission.allRoutes,
  indexPage: (state) => state.permission.indexPage,
  viewCache: (state) => state.permission.viewCache,
  listLenght: (state) => state.common.listLenght,
  setReportTitle: (state) => state.common.setReportTitle,
  setTitle: (state) => state.common.setTitle,
  setRoleSubTitle: (state) => state.common.setRoleSubTitle,
  setHeaderMent: (state) => state.common.setHeaderMent,
  setFactoryId: (state) => state.common.setFactoryId,
  setFleetId: (state) => state.common.setFleetId,
  setAgentId: (state) => state.common.setAgentId,
  setTerritoryId: (state) => state.common.setTerritoryId,
  setTableLoading: (state) => state.common.setTableLoading,
  setDialogTableLoading: (state) => state.common.setDialogTableLoading,
  setRoleTypeList: (state) => state.common.setRoleTypeList,
  setUserAdminList: (state) => state.common.setUserAdminList,
  setUserServiceEngineerList: (state) => state.common.setUserServiceEngineerList,
  setFile: (state) => state.common.setFile,
  setDialogConfirmBtn: (state) => state.common.setDialogConfirmBtn,
  setPreFleetTitle: (state) => state.common.setPreFleetTitle,
  setPreSubFleetTitle: (state) => state.common.setPreSubFleetTitle,
  roleKey: (state) => state.permission.roleKey,
}
export default getters
